import { gql, useLazyQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import { getWorkflow } from 'modules/workflows/ducks';
import { Optimization } from 'modules/workflows/types';

export const getJourneyOptimizationsQuery = gql`
  query getJourneyOptimizations($id: Long!) {
    getJourneyOptimizations(id: $id) {
      optimizations {
        ... on MergeStartYesNoSplitTiles {
          optimizationType
          description
          nodeIds
        }
        ... on MergeChainedChannelSubscriptionTiles {
          optimizationType
          description
          nodeIds
        }
        ... on MergeChainedMessageSubscriptionTiles {
          optimizationType
          description
          nodeIds
        }
      }
    }
  }
`;

type updateJourneyOptimizationsResponse = {
  getJourneyOptimizations: {
    optimizations: Optimization[];
  };
};

export const useGetJourneyOptimizations = ({
  onGetOptimizationsSuccess,
  onGetOptimizationsError,
}: {
  onGetOptimizationsSuccess?: (optimizations: Optimization[]) => void;
  onGetOptimizationsError?: () => void;
}) => {
  const workflow = useSelector(getWorkflow);

  const [getJourneyOptimizations, { data, error, loading }] =
    useLazyQuery<updateJourneyOptimizationsResponse>(getJourneyOptimizationsQuery, {
      fetchPolicy: 'no-cache',
      onCompleted: (res) => {
        if (onGetOptimizationsSuccess) {
          onGetOptimizationsSuccess(res.getJourneyOptimizations.optimizations);
        }
      },
      onError: () => {
        if (onGetOptimizationsError) {
          onGetOptimizationsError();
        }
      },
    });

  const getOptimizations = () => {
    getJourneyOptimizations({
      variables: {
        id: workflow.id,
      },
    });
  };

  return {
    getOptimizations,
    optimizationsData: data?.getJourneyOptimizations?.optimizations || [],
    isLoading: loading,
    hasError: !!error,
  };
};
